import { Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
  dataCy?: string
}
export const TableCentralizedCell = ({ children, dataCy }: Props) => (
  <Typography textAlign={'center'} width='100%' variant='subtitle1' data-cy={dataCy}>
    {children}
  </Typography>
)
